import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";

const useNoticeQuery = (id: string) => {
  return useSuspenseQuery({
    queryKey: api.notice.getNoticeByIdKey(id),
    queryFn: () => api.notice.getNoticeById(id),
  });
};

export default useNoticeQuery;
